import { paths } from '../../common/constants/pathVariables.js';
import { omaElisaForCompaniesMsg, supportCasesAndMessagesMsg, t } from '../../common/i18n/index.js';
import { BreadCrumbsWithTitle } from '../../components/BreadCrumbsWithTitle/BreadCrumbsWithTitle.js';
import { BlankHeading } from '../BlankHeading/BlankHeading.js';
import { NewSupportCase } from '../NewSupportCase/NewSupportCase.js';
import type { BillChannel } from '../../generated/api/billChannel';
import type { CompanyInfoResponse } from '../../generated/api/companyInfoResponse';

import './NewSupportCaseAuthenticated.scss';

interface NewSupportCaseAuthenticatedProps {
  billChannels: BillChannel[];
  companyInfo?: CompanyInfoResponse;
}

export const NewSupportCaseAuthenticated = ({ billChannels, companyInfo }: NewSupportCaseAuthenticatedProps) => {
  return (
    <div className="of-create-case-authenticated">
      <BlankHeading
        detailsTop={
          <BreadCrumbsWithTitle
            breadCrumbPaths={[
              { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
              { name: t.NPCK(supportCasesAndMessagesMsg), path: paths.MESSAGE_CENTER_SUPPORT_CASES },
              { name: t.TFDQ('Create new') },
            ]}
          />
        }
        title={t.CZNY('Create a message or support case')}
      />
      <div className="content">
        <NewSupportCase selfService={true} billChannels={billChannels} companyInfo={companyInfo} />
      </div>
    </div>
  );
};
